import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthenticationService } from './authentication.service';

@Injectable({
  providedIn: 'root',
})
export class AuthGuardService implements CanActivate {
  constructor(
    private authService: AuthenticationService,
    private router: Router
  ) {}

  async canActivate(): Promise<boolean> {
    const authStatus = await this.authService.authenticationStatus();

    if (authStatus.authenticated) {
      return true;
    }
    this.router.navigate(['/login']);
    return false;
  }
}
